import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class RemoveChecklistItemErrorAction implements Action {
  public static readonly type = 'RemoveChecklistItemErrorAction';

  constructor(public error: BijbError) {
  }

  public type = RemoveChecklistItemErrorAction.type;
}

